import ContratoInterceptor from '@finx/web-repository/src/apis/Contrato/ContratoInterceptor'
import RemuneracaoMedicaInterceptor from '@finx/web-repository/src/apis/RemuneracaoMedica/RemuneracaoMedicaInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import ResponseApi from '@/types/interfaces/FactoryResponse'
import { Gestor, ProfissionalExecutanteContrato, Prestador } from '@/types/interfaces/Contrato'
import { toHttpParams } from '@/utils/common'

const factory = new FactoryResponse()
const api = new ContratoInterceptor()
const apiRM = new RemuneracaoMedicaInterceptor()

export default {
  async getAllContratos(prestadorId: string) {
    const request = await api.get(`contratos-hospitais?prestadorId=${prestadorId}`)
    return factory.build(request)
  },

  async getContratoById(contratoId: string) {
    const request = await api.get(`contratos-hospitais/${contratoId}`)
    return factory.build(request)
  },

  async getAllPrestadoresByHospital() {
    const request = await api.get('contratos-hospitais/prestadores')
    return factory.build(request)
  },

  async getAllPrestadores() {
    const request = await api.get('prestadores')
    return factory.build(request)
  },

  async getPrestadoresBySearch(search: string, limite?: number): Promise<ResponseApi<Prestador[]>> {
    const limiteQuery = limite ? `&limite=${limite}` : ''
    const request = await api.get(`prestadores/busca?search=${encodeURIComponent(search)}${limiteQuery}`)
    return factory.build<Prestador[]>(request)
  },

  async getAllGestores() {
    const request = await api.get('gestores')
    return factory.build(request)
  },

  async getGestoresBySearch(params: { nome?: string, cpf?: string, limite?: number }): Promise<ResponseApi<Gestor[]>> {
    const queryParams = toHttpParams({
      nome: params.nome || undefined,
      cpf: params.cpf || undefined,
      limite: params.limite,
    })
    const request = await api.get(`gestores/busca?${queryParams}`)
    return factory.build<Gestor[]>(request)
  },

  async getAllProfissionais(params?: any) {
    let query = ''

    if (params && params.nome) {
      query = `?nome=${params.nome}`
    }

    const request = await api.get(`profissionais-executantes${query}`)
    return factory.build(request)
  },

  async getProfissionaisBySearch(params: { nome?: string, cpf?: string, limite?: number }): Promise<ResponseApi<ProfissionalExecutanteContrato[]>> {
    const queryParams = toHttpParams({
      nome: params.nome || undefined,
      cpf: params.cpf || undefined,
      limite: params.limite,
    })
    const request = await api.get(`profissionais-executantes/busca?${queryParams}`)
    return factory.build<ProfissionalExecutanteContrato[]>(request)
  },

  async getAllRegrasDisponiveis(contratoId: string) {
    const request = await api.get(`contratos-hospitais/${contratoId}/regras-disponiveis`)
    return factory.build(request)
  },

  async postGestoresByContratoId(contratoId: string, payload: string[]) {
    const request = await api.post(`contratos-hospitais/${contratoId}/gestores`, payload)
    return factory.build(request)
  },

  async postProfissionaisByContratoId(contratoId: string, payload: string[]) {
    const request = await api.post(`contratos-hospitais/${contratoId}/profissionais-executantes`, payload)
    return factory.build(request)
  },

  async postRegrasByContratoId(contratoId: string, payload: string[]) {
    const request = await api.post(`contratos-hospitais/${contratoId}/regras`, payload)
    return factory.build(request)
  },

  async deleteRegrasByContratoId(contratoId: string, regraId: string) {
    const request = await api.delete(`contratos-hospitais/${contratoId}/regras/${regraId}`)
    return factory.build(request)
  },

  async deleteGestoresByContratoId(contratoId: string, payload: string[]) {
    const request = await api.post(`contratos-hospitais/${contratoId}/gestores/delete`, payload)
    return factory.build(request)
  },

  async deleteProfissionaisByContratoId(contratoId: string, payload: string[]) {
    const request = await api.post(`contratos-hospitais/${contratoId}/profissionais-executantes/delete`, payload)
    return factory.build(request)
  },

  async removeContratoGestor(params: any) {
    const request = await api.delete(`contratos/${params.contratoId}/gestores/${params.gestorId}`)
    return factory.build(request)
  },

  async addGestor(contratoId: string, params: any) {
    const request = await api.post(`contratos/${contratoId}/gestores?ehCadastradoPorGestor=true`, params)
    return factory.build(request)
  },

  async addNovoContrato(params: any) {
    const request = await api.post('contratos', params)
    return factory.build(request)
  },

  async getContratosVisaoGestor(base: string, params?: any) {
    const requestConfig = {
      'principal': {
        urlEndpoint: 'contratos/visao-gestor',
        apiInstance: apiRM
      },
      'contrato': {
        urlEndpoint: 'contratos-hospitais/visao-gestor',
        apiInstance: api
      }
    }
    const urlEndpoint = requestConfig[base].urlEndpoint
    const request = await requestConfig[base].apiInstance.get(`${urlEndpoint}${params}`)
    return factory.build(request)
  },

  async getGrupoHospitalOptions() {
    const request = await apiRM.get('contratos-hospitais')
    return factory.build(request)
  },
}
